/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type Company,
    CompanyFromJSON,
    CompanyToJSON,
} from '../models/Company';
import {
    type PaginatedDataPointStatsList,
    PaginatedDataPointStatsListFromJSON,
    PaginatedDataPointStatsListToJSON,
} from '../models/PaginatedDataPointStatsList';
import {
    type PaginatedOperatorStatsList,
    PaginatedOperatorStatsListFromJSON,
    PaginatedOperatorStatsListToJSON,
} from '../models/PaginatedOperatorStatsList';

export interface AdminAccountsCompaniesListRequest {
    ordering?: string;
}

export interface AdminAccountsCompaniesRetrieveRequest {
    id: number;
}

export interface AdminDataPointsStatsListRequest {
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface AdminEmissionsRecordsStatsListRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<AdminEmissionsRecordsStatsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    epaSepNotificationReason?: Array<AdminEmissionsRecordsStatsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<AdminEmissionsRecordsStatsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<AdminEmissionsRecordsStatsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<AdminEmissionsRecordsStatsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminAccountsCompaniesList without sending the request
     */
    async adminAccountsCompaniesListRequestOpts(requestParameters: AdminAccountsCompaniesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/accounts/companies/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve company names.
     */
    async adminAccountsCompaniesListRaw(requestParameters: AdminAccountsCompaniesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Company>>> {
        const requestOptions = await this.adminAccountsCompaniesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyFromJSON));
    }

    /**
     * A viewset to retrieve company names.
     */
    async adminAccountsCompaniesList(requestParameters: AdminAccountsCompaniesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Company>> {
        const response = await this.adminAccountsCompaniesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminAccountsCompaniesRetrieve without sending the request
     */
    async adminAccountsCompaniesRetrieveRequestOpts(requestParameters: AdminAccountsCompaniesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminAccountsCompaniesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/accounts/companies/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve company names.
     */
    async adminAccountsCompaniesRetrieveRaw(requestParameters: AdminAccountsCompaniesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Company>> {
        const requestOptions = await this.adminAccountsCompaniesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanyFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve company names.
     */
    async adminAccountsCompaniesRetrieve(requestParameters: AdminAccountsCompaniesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Company> {
        const response = await this.adminAccountsCompaniesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDataPointsStatsList without sending the request
     */
    async adminDataPointsStatsListRequestOpts(requestParameters: AdminDataPointsStatsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/data-points/stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns statistics for data points.
     */
    async adminDataPointsStatsListRaw(requestParameters: AdminDataPointsStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataPointStatsList>> {
        const requestOptions = await this.adminDataPointsStatsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataPointStatsListFromJSON(jsonValue));
    }

    /**
     * Returns statistics for data points.
     */
    async adminDataPointsStatsList(requestParameters: AdminDataPointsStatsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataPointStatsList> {
        const response = await this.adminDataPointsStatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminEmissionsRecordsStatsList without sending the request
     */
    async adminEmissionsRecordsStatsListRequestOpts(requestParameters: AdminEmissionsRecordsStatsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/admin/emissions-records/stats/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns statistics for data points.
     */
    async adminEmissionsRecordsStatsListRaw(requestParameters: AdminEmissionsRecordsStatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedOperatorStatsList>> {
        const requestOptions = await this.adminEmissionsRecordsStatsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedOperatorStatsListFromJSON(jsonValue));
    }

    /**
     * Returns statistics for data points.
     */
    async adminEmissionsRecordsStatsList(requestParameters: AdminEmissionsRecordsStatsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedOperatorStatsList> {
        const response = await this.adminEmissionsRecordsStatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AdminEmissionsRecordsStatsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type AdminEmissionsRecordsStatsListDataSourceEnum = typeof AdminEmissionsRecordsStatsListDataSourceEnum[keyof typeof AdminEmissionsRecordsStatsListDataSourceEnum];
/**
 * @export
 */
export const AdminEmissionsRecordsStatsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type AdminEmissionsRecordsStatsListEpaSepNotificationReasonEnum = typeof AdminEmissionsRecordsStatsListEpaSepNotificationReasonEnum[keyof typeof AdminEmissionsRecordsStatsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const AdminEmissionsRecordsStatsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type AdminEmissionsRecordsStatsListEventStatusEnum = typeof AdminEmissionsRecordsStatsListEventStatusEnum[keyof typeof AdminEmissionsRecordsStatsListEventStatusEnum];
/**
 * @export
 */
export const AdminEmissionsRecordsStatsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type AdminEmissionsRecordsStatsListEventStatusWithParentStatusEnum = typeof AdminEmissionsRecordsStatsListEventStatusWithParentStatusEnum[keyof typeof AdminEmissionsRecordsStatsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const AdminEmissionsRecordsStatsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type AdminEmissionsRecordsStatsListExcludeEventStatusEnum = typeof AdminEmissionsRecordsStatsListExcludeEventStatusEnum[keyof typeof AdminEmissionsRecordsStatsListExcludeEventStatusEnum];
